import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import moment from "moment";
import { LagermalRequest, LagermalView } from "../../hantera-lagermal-models";

@Component({
    selector: "rask-hantera-lagermal-navigation",
    templateUrl: "./hantera-lagermal-navigation.component.html",
    styleUrls: ["./hantera-lagermal-navigation.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ButtonComponent,
        RadiobuttonGroupComponent,
        FormsModule
    ]
})
export class HanteraLagermalNavigationComponent {

    displayFilter: string;
  @Input() lagermalFilter: LagermalRequest;
  @Output() yearChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() viewChange: EventEmitter<LagermalView> = new EventEmitter<LagermalView>();
  views = [
      { key: LagermalView.Dagar,
          value: "Antal dagar" },
      { key: LagermalView.Kvantitet,
          value: "Kvantitet i m3f" }
  ];
  @Input() selectedView = LagermalView.Dagar;

  getDisplayedFilter(): string {
      const mo = `MARKNADSOMRÅDE: ${this.lagermalFilter.monamn}`;
      const po = (this.lagermalFilter.produktionsomradeId ? `. PRODUKTIONSOMRÅDE: ${this.lagermalFilter.ponamn}` : "");
      const y = ` - ${moment(this.lagermalFilter.period).year()}`;

      return `${mo}${po}${y}`;
  }

  changeView(event: LagermalView) {
      this.viewChange.emit(event);
  }

  nextYear() {
      this.yearChange.emit(1);
  }

  previousYear() {
      this.yearChange.emit(-1);
  }

}
